import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.css']
})
export class CustomerDetailsComponent implements OnInit {

  constructor(private productService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  output:any=[]; //---store get() result--------
  customerId='';
  //getUrl='http://192.241.151.66:5000/viewCustomers';
   //-------date formating-------------
   today: Date = new Date();
   pipe = new DatePipe('en-US');
   EarliestDate:any= null;
   OldestDate:any=null;
   name=""

  //------function for routing to customer visit details-----------
  CustomerVisitDetails(){
    this.router.navigateByUrl(('admin/customer-visit-details'));  
  }
  
  //--------function which give id of selected customer---------
  getVisitValue = (item : string) =>{
     
    this.productService.setCustomerId(item)
  
  }
//--------function which give id of selected customer---------
getValue(){  
  this.productService.setCustomerId(this.customerId)
  document.body.scrollTop = document.documentElement.scrollTop = 0;
}
//----------function routing to edit customer---------
EditCustomer(){
  this.router.navigateByUrl(('admin/edit-customer'));  
  console.log("call edit product")
}
  //------function for routing to receipt details-------------------------

  ReceiptDetails(){
    this.router.navigateByUrl(('admin/receipts-detail'));  
  }
  
  //--------function which give id of selected item---------
  getReceiptValue = (item : string) =>{
     
    this.productService.setReceiptId(item)
    console.log("id=",item)
  
  }
  
  ngOnInit(): void {

    //---call function in service for customer Id------
    this.customerId=this.productService.getCustomerId()
    console.log("customerss id=",this.customerId)

   //-------api get()calling-------------
   this.productService.CutomerDetails('/'+this.customerId).subscribe((res)=>{
     this.output=res.data
     console.log("customer details =",this.output)
     this.name=this.output[0].customer_name
    //-------date formating----------------------
    this.EarliestDate = this.pipe.transform(this.output[0].earliest_overdue_date, 'MMM d, y, h:mm:ss a');
    this.OldestDate = this.pipe.transform(this.output[0].oldest_due_inv_date, 'MMM d, y, h:mm:ss a');
   })

  }

}
